module.exports = __webpack_public_path__ + "img/s.c0b326ef.svg";